import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {NavigationService} from '../services/navigation.service';

export const ChallengeGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const navigationService: NavigationService = inject(NavigationService);

  if (authService.getChallenge()) {
    return true;
  } else {
    navigationService.goToLogin();
    return false;
  }
};
